export const WIDGET_ID = "widget-top-keywords";
